// Combines the two live catalogue formats into the single category list the
// effect picker renders.
//
//   legacy    /database                        → gelijke-kansen (and arbeidsparticipatie, filtered out)
//   versioned /meetstandaard/{sector}/{version} → every pinned sector
//
// The legacy list is passed through as-is, except for the effects of a sector
// that is now pinned: those would otherwise appear twice, once under their
// /database UUID and once under their uid (withoutPinnedSectors).

import { PINNED_STANDAARD_VERSIONS } from './standaardVersions'
import withoutPinnedSectors from './withoutPinnedSectors'

/**
 * @param {Array<object>|null|undefined} legacyCategories - /database response
 * @param {Array<{sector: string, version: string, effects: Array<object>}>|null|undefined} adaptedDocuments
 * @returns {Array<{id: string, name: string, effects: Array<object>}>}
 */
const mergeStandaardCatalogs = (legacyCategories, adaptedDocuments) => {
    const legacy = withoutPinnedSectors(legacyCategories, PINNED_STANDAARD_VERSIONS)
    const documents = Array.isArray(adaptedDocuments) ? adaptedDocuments : []

    /** @type {Array<{id: string, name: string, effects: Array<object>}>} */
    const versionedCategories = []

    documents.forEach((doc) => {
        const sector = doc?.sector || ''
        const effects = Array.isArray(doc?.effects) ? doc.effects : []

        /** @type {Map<string, Array<object>>} */
        const byCategory = new Map()

        effects.forEach((effect) => {
            // An effect with no usable statements cannot become a matrix —
            // adopting it would create a questionnaire with nothing to answer.
            const questions = Array.isArray(effect?.questions) ? effect.questions : []
            if (questions.length === 0) return

            const category = effect.category || 'Overig'
            if (!byCategory.has(category)) byCategory.set(category, [])
            byCategory.get(category).push(effect)
        })

        byCategory.forEach((categoryEffects, category) => {
            versionedCategories.push({
                // Sector-scoped: two standaarden can use the same category name.
                id: `${sector}:${category}`,
                name: category,
                effects: categoryEffects,
            })
        })
    })

    return [...legacy, ...versionedCategories]
}

export default mergeStandaardCatalogs
